<script>
  export const IMAGE_DIMENSIONS = {
    simple: {
      width: 135,
      height: 135
    },
    teaser: {
      width: 300,
      height: 170
    },
    teaserBig: {
      width: 630,
      height: 360
    },
    indicator: {
      width: 95,
      height: 56
    },
    award: {
      width: 135,
      height: 70
    },
    icon: {
      width: 24,
      height: 24
    }
  }

  export default {
    props: {
      url: String,
      isCoreMedia: Boolean,
      alt: String,
      lazy: Boolean,
      width: {
        type: Number,
        required: false
      },
      height: {
        type: Number,
        required: false
      }
    },
    methods: {
      imageSize (isWebp) {
        if (this.isCoreMedia) {
          const imageURL = this.url.indexOf('.jpg') > -1 && isWebp ? this.url.replace('.jpg', '.webp') : this.url
          const pdRegex = /pd=[0-9]*/
          const pdParam = imageURL.match(pdRegex)
          const sizePosition = pdParam && pdParam[0] ? imageURL.search(pdRegex) + pdParam[0].length : imageURL.lastIndexOf('.')

          return `${imageURL.slice(0, sizePosition)},h=${this.height},w=${this.width}${imageURL.slice(sizePosition)}`
        }

        return this.url
      }
    },
    computed: {
      src () {
        return this.imageSize(false)
      },
      webp () {
        return this.imageSize(true)
      }
    }
  }
</script>

<template>
  <picture v-if="isCoreMedia">
    <source :srcset="webp" type="image/webp">
    <img :loading="lazy ? 'lazy' : false" :src="src"  :alt="alt || false" :width="width" :height="height" />
  </picture>
  <img v-else :loading="lazy ? 'lazy' : false" :src="src"  :alt="alt || false" :width="width" :height="height" />
</template>
